/* Carole — Style Quiz + For You engine
   Single shared asset used by sections/style-quiz.liquid, sections/for-you.liquid
   and sections/my-style.liquid. No dependencies. */
(function () {
  'use strict';

  var KEY = 'carole_style_profile';
  var SEEN = 'carole_quiz_seen';
  var FEED_KEY = 'carole_feed_v3_strict';
  var FEED_TTL = 30 * 60 * 1000; // 30 min
  var VERSION = 2;

  /* ---------------------------------------------------------------
     i18n — the store runs EN + FR. Everything the shopper reads
     lives here so there is one place to edit copy.
     --------------------------------------------------------------- */
  var STRINGS = {
    en: {
      step: 'Step',
      of: 'of',
      back: 'Back',
      next: 'Continue',
      skip: 'Skip',
      finish: 'See my selection',
      close: 'Close',

      q1_eyebrow: 'Question 1',
      q1_title: "Who are we shopping for?",
      q1_sub: 'Most of our vintage is unisex — this just hides what would not fit.',
      q1_men: 'Men',
      q1_women: 'Women',
      q1_all: 'Show me everything',

      q2_eyebrow: 'Question 2',
      q2_title: 'What are you after?',
      q2_sub: 'Pick as many as you like.',

      q3_eyebrow: 'Question 3',
      q3_title: 'What size do you wear on top?',
      q3_sub: 'Pick every size you would actually wear.',
      q3_oversized: 'I like it oversized — size me up',

      q4_eyebrow: 'Question 4',
      q4_title: 'And on the bottom?',
      q4_sub: 'Waist in inches — pick every size that fits. Skip if you are not after pants.',

      q5_eyebrow: 'Question 5',
      q5_title: 'What is your thing?',
      q5_sub: 'Pick as many as you like. This is what shapes your feed.',

      select_all: 'Select all',
      clear_all: 'Clear all',

      q6_eyebrow: 'Question 6',
      q6_title: 'Any brands you love?',
      q6_sub: 'Optional — we will float them to the top.',

      em_offer: '10% off your first order',
      em_title: 'Where should we send it?',
      em_sub: 'Your code, plus first look at every new drop that matches your style.',
      em_email: 'Email address',
      em_phone: 'Phone (optional — for drop alerts)',
      em_cta: 'Get my 10% off',
      em_nothanks: 'No thanks, just show me the clothes',
      em_invalid: 'That email does not look right.',
      em_legal: 'One-time 10% code on your first order. You can unsubscribe at any time.',
      em_sending: 'Sending…',

      done_title: 'You are all set',
      done_sub: 'Here is your code — it is waiting in your inbox too.',
      done_cta: 'See my selection',
      done_account: 'Create my account',
      done_account_sub: 'Save your style so it follows you on any device.',

      fy_title: 'For You',
      fy_sub: 'items picked from your answers',
      fy_none_title: 'Tell us what you like',
      fy_none_sub: 'Answer six quick questions and we will build a feed out of the pieces that actually fit you.',
      fy_none_cta: 'Start the style quiz',
      fy_edit: 'Edit my preferences',
      fy_retake: 'Retake the quiz',
      fy_more: 'Load more',
      fy_loading: 'Building your selection…',
      fy_error: 'We could not load your selection. Please refresh the page.',
      fy_widened: 'Your chosen categories and sizes are respected.',
      fy_no_matches: 'No pieces currently match these categories and sizes. You can edit your preferences or check back for new arrivals.',
      fy_new: 'New',
      fy_sale: 'Sale',

      ms_title: 'My style',
      ms_sub: 'Change anything here and your For You feed updates right away.',
      ms_save: 'Save my preferences',
      ms_saved: 'Saved',
      ms_clear: 'Clear my preferences',
      ms_gender: 'Shopping for',
      ms_families: 'Categories',
      ms_top: 'Top size',
      ms_bottom: 'Waist (inches)',
      ms_styles: 'Styles',
      ms_brands: 'Brands',
      ms_none: 'You have not taken the quiz yet.'
    },
    fr: {
      step: 'Étape',
      of: 'sur',
      back: 'Retour',
      next: 'Continuer',
      skip: 'Passer',
      finish: 'Voir ma sélection',
      close: 'Fermer',

      q1_eyebrow: 'Question 1',
      q1_title: 'On magasine pour qui ?',
      q1_sub: 'La plupart de nos pièces sont unisexes — ça sert juste à cacher ce qui ne t’irait pas.',
      q1_men: 'Homme',
      q1_women: 'Femme',
      q1_all: 'Montre-moi tout',

      q2_eyebrow: 'Question 2',
      q2_title: 'Tu cherches quoi ?',
      q2_sub: 'Choisis-en autant que tu veux.',

      q3_eyebrow: 'Question 3',
      q3_title: 'Quelle taille tu portes en haut ?',
      q3_sub: 'Coche toutes les tailles que tu porterais vraiment.',
      q3_oversized: 'Je l’aime oversized — monte-moi d’une taille',

      q4_eyebrow: 'Question 4',
      q4_title: 'Et en bas ?',
      q4_sub: 'Tour de taille en pouces — coche toutes celles qui te font. Passe si tu ne cherches pas de pantalon.',

      q5_eyebrow: 'Question 5',
      q5_title: 'C’est quoi ton style ?',
      q5_sub: 'Choisis-en autant que tu veux. C’est ce qui construit ton fil.',

      select_all: 'Tout sélectionner',
      clear_all: 'Tout effacer',

      q6_eyebrow: 'Question 6',
      q6_title: 'Des marques que tu aimes ?',
      q6_sub: 'Optionnel — on va les remonter en haut.',

      em_offer: '10 % sur ta première commande',
      em_title: 'On l’envoie où ?',
      em_sub: 'Ton code, plus le premier coup d’œil sur chaque arrivage qui matche ton style.',
      em_email: 'Adresse courriel',
      em_phone: 'Téléphone (optionnel — pour les alertes d’arrivage)',
      em_cta: 'Obtenir mon 10 %',
      em_nothanks: 'Non merci, montre-moi juste le linge',
      em_invalid: 'Ce courriel a l’air incomplet.',
      em_legal: 'Code de 10 % à usage unique sur ta première commande. Tu peux te désabonner en tout temps.',
      em_sending: 'Envoi…',

      done_title: 'C’est fait',
      done_sub: 'Voici ton code — il est aussi dans ta boîte de réception.',
      done_cta: 'Voir ma sélection',
      done_account: 'Créer mon compte',
      done_account_sub: 'Garde ton style enregistré, peu importe l’appareil.',

      fy_title: 'Pour toi',
      fy_sub: 'pièces choisies selon tes réponses',
      fy_none_title: 'Dis-nous ce que tu aimes',
      fy_none_sub: 'Six questions rapides et on te construit un fil avec les pièces qui te vont vraiment.',
      fy_none_cta: 'Commencer le quiz',
      fy_edit: 'Modifier mes préférences',
      fy_retake: 'Refaire le quiz',
      fy_more: 'Voir plus',
      fy_loading: 'On construit ta sélection…',
      fy_error: 'Impossible de charger ta sélection. Rafraîchis la page.',
      fy_widened: 'Tes catégories et tes tailles sont respectées.',
      fy_no_matches: 'Aucune pièce disponible dans ces catégories et ces tailles pour le moment. Modifie tes préférences ou reviens découvrir les prochains arrivages.',
      fy_new: 'Nouveau',
      fy_sale: 'Solde',

      ms_title: 'Mon style',
      ms_sub: 'Change ce que tu veux ici, ton fil Pour toi se met à jour tout de suite.',
      ms_save: 'Enregistrer mes préférences',
      ms_saved: 'Enregistré',
      ms_clear: 'Effacer mes préférences',
      ms_gender: 'Je magasine pour',
      ms_families: 'Catégories',
      ms_top: 'Taille du haut',
      ms_bottom: 'Tour de taille (pouces)',
      ms_styles: 'Styles',
      ms_brands: 'Marques',
      ms_none: 'Tu n’as pas encore fait le quiz.'
    }
  };

  function lang() {
    var l = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    return l.indexOf('fr') === 0 ? 'fr' : 'en';
  }
  function t(key) {
    var L = STRINGS[lang()] || STRINGS.en;
    return L[key] != null ? L[key] : (STRINGS.en[key] || key);
  }

  /* ---------------------------------------------------------------
     Vocabulary — must stay in sync with the catalogue.
     Values are the exact strings stored on the products.
     --------------------------------------------------------------- */
  var TOP_SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];

  // Waist, in inches. Matches how bottoms sizes are stored ("34", "34/32", '32" W - 30" L').
  var WAIST_SIZES = ['24', '26', '28', '29', '30', '31', '32', '33', '34', '35', '36', '38', '40', '42', '44', '46'];

  // A category is matched either by the product's family tag, or — where the tag
  // is too coarse for what shoppers actually ask for — by product type.
  var FAMILIES = [
    { v: 'TShirts', types: ['T-Shirt', 'Long Sleeve T-Shirt'], en: 'T-shirts', fr: 'T-shirts' },
    { v: 'Shirts', types: ['Shirt', 'Polo'], en: 'Shirts & polos', fr: 'Chemises & polos' },
    { v: 'Sweats', tag: 'Sweats', en: 'Crewnecks & hoodies', fr: 'Chandails & kangourous' },
    { v: 'Outerwear', tag: 'Outerwear', en: 'Jackets & coats', fr: 'Manteaux & vestes' },
    { v: 'Jerseys', tag: 'Jerseys', en: 'Jerseys', fr: 'Maillots' },
    { v: 'Fleece', tag: 'Fleece', en: 'Fleece', fr: 'Polaires' },
    { v: 'Knitwear', tag: 'Knitwear', en: 'Knitwear', fr: 'Tricots' },
    { v: 'Pants', types: ['Jeans', 'Pants', 'Cargo Pants', 'Track Pants', 'Tracksuit'], en: 'Pants & jeans', fr: 'Pantalons & jeans' },
    { v: 'Shorts', types: ['Shorts'], en: 'Shorts', fr: 'Shorts' }
  ];

  var STYLES = [
    { v: 'Sport', en: 'Sport', fr: 'Sport' },
    { v: 'University', en: 'College', fr: 'Collégial' },
    { v: 'Brand', en: 'Big logos', fr: 'Gros logos' },
    { v: 'Graphic and Vintage', en: 'Graphic & vintage', fr: 'Graphique & vintage' },
    { v: 'Y2K', en: 'Y2K', fr: 'Y2K' },
    { v: 'Streetwear', en: 'Streetwear', fr: 'Streetwear' },
    { v: 'Workwear', en: 'Workwear', fr: 'Workwear' },
    { v: 'Outdoor', en: 'Outdoor', fr: 'Plein air' },
    { v: 'Nascar and Harley Davidson', en: 'Nascar & Harley', fr: 'Nascar & Harley' },
    { v: 'Camo / Military', en: 'Camo & military', fr: 'Camo & militaire' },
    { v: 'Music / Band', en: 'Music & bands', fr: 'Musique & groupes' },
    { v: 'Preppy', en: 'Preppy', fr: 'Preppy' },
    { v: 'Cartoon', en: 'Cartoons', fr: 'Dessins animés' },
    { v: 'Denim', en: 'Denim', fr: 'Denim' },
    { v: 'Leather', en: 'Leather', fr: 'Cuir' }
  ];

  var BRANDS = [
    'Nike', 'Carhartt', 'The North Face', "Levi's", 'Adidas', 'Champion',
    'Tommy Hilfiger', 'Ralph Lauren', 'Patagonia', 'Wrangler',
    'Harley-Davidson', 'Reebok', 'Dickies', 'Lacoste'
  ];

  function label(item) {
    return lang() === 'fr' ? item.fr : item.en;
  }

  /* ---------------------------------------------------------------
     Profile storage
     --------------------------------------------------------------- */
  function blank() {
    return {
      v: VERSION,
      ts: 0,
      gender: '',
      families: [],
      topSizes: [],
      oversized: false,
      waistSizes: [],
      styles: [],
      brands: [],
      email: '',
      done: false
    };
  }

  function get() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || p.v !== VERSION) return null;
      var b = blank();
      for (var k in b) { if (!(k in p)) p[k] = b[k]; }
      return p;
    } catch (e) { return null; }
  }

  function isComplete(p) {
    return !!(p && p.v === VERSION && p.done === true && p.gender && Array.isArray(p.families) && p.families.length && Array.isArray(p.topSizes) && p.topSizes.length);
  }

  function save(p) {
    p.v = VERSION;
    p.ts = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {}
    try { document.cookie = 'carole_has_profile=1; path=/; max-age=' + 60 * 60 * 24 * 365 + '; SameSite=Lax'; } catch (e) {}
    return p;
  }

  function clear() {
    try { localStorage.removeItem(KEY); localStorage.removeItem(SEEN); } catch (e) {}
    try { document.cookie = 'carole_has_profile=; path=/; max-age=0'; } catch (e) {}
  }

  function seen() {
    try { return localStorage.getItem(SEEN) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    try { localStorage.setItem(SEEN, '1'); } catch (e) {}
  }

  /* ---------------------------------------------------------------
     Feed
     --------------------------------------------------------------- */
  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }

  function fetchPage(handle, page) {
    var url = root() + '/collections/' + handle + '?view=foryou-feed&page=' + page;
    return fetch(url, { headers: { 'X-Requested-With': 'fetch' } }).then(function (r) {
      if (!r.ok) throw new Error('feed ' + r.status);
      return r.json();
    });
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(FEED_KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || Date.now() - c.ts > FEED_TTL) return null;
      return c.products;
    } catch (e) { return null; }
  }
  function writeCache(products) {
    try { sessionStorage.setItem(FEED_KEY, JSON.stringify({ ts: Date.now(), products: products })); } catch (e) {}
  }

  // Loads the whole catalogue in compact form. Page 1 first (so the caller can
  // paint something immediately), then the rest in parallel.
  function loadFeed(handle, onPartial) {
    var cached = readCache();
    if (cached) return Promise.resolve(cached);

    return fetchPage(handle, 1).then(function (first) {
      var all = first.products || [];
      if (onPartial) { try { onPartial(all.slice(), false); } catch (e) {} }
      var pages = Math.min(first.pages || 1, 12);
      if (pages < 2) { writeCache(all); return all; }

      var rest = [];
      for (var i = 2; i <= pages; i++) rest.push(fetchPage(handle, i));
      return Promise.all(rest.map(function (p) {
        return p.catch(function () { return { products: [] }; });
      })).then(function (results) {
        results.forEach(function (r) { all = all.concat(r.products || []); });
        writeCache(all);
        return all;
      });
    });
  }

  /* ---------------------------------------------------------------
     Scoring
     --------------------------------------------------------------- */
  var TYPE_TO_FAMILY = {};
  var TAG_TO_FAMILY = {};
  FAMILIES.forEach(function (f) {
    (f.types || []).forEach(function (ty) { TYPE_TO_FAMILY[ty] = f.v; });
    if (f.tag) TAG_TO_FAMILY[f.tag] = f.v;
  });

  var BOTTOM_FAMILIES = { Pants: true, Shorts: true };

  // Product type wins where we defined one (t-shirts vs shirts, pants vs shorts);
  // otherwise fall back to the family tag on the product.
  function familyOf(p) {
    if (p.ty && TYPE_TO_FAMILY[p.ty]) return TYPE_TO_FAMILY[p.ty];
    var tags = p.tg || [];
    for (var i = 0; i < tags.length; i++) {
      if (TAG_TO_FAMILY[tags[i]]) return TAG_TO_FAMILY[tags[i]];
      if (TYPE_TO_FAMILY[tags[i]]) return TYPE_TO_FAMILY[tags[i]];
    }
    if (tags.indexOf('Bottoms') !== -1) return 'Pants';
    // A generic Tops tag cannot distinguish a shirt from a jacket.
    return '';
  }

  function genderOf(p) {
    var tags = p.tg || [];
    for (var i = 0; i < tags.length; i++) {
      var g = tags[i];
      if (g === 'Men' || g === 'Women' || g === 'Unisex' || g === 'Youth') return g;
    }
    return '';
  }

  // "L", "XL", "L|XL", "34/10", "29\" W - 34\" L", "38"
  function sizesOf(p) {
    return String(p.sz || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function waistOf(sizeStr) {
    var m = String(sizeStr).match(/(\d{2})/);
    if (!m) return null;
    var w = parseInt(m[1], 10);
    return (w >= 20 && w <= 60) ? w : null;
  }

  function normalizeSize(value) {
    var s = String(value || '').trim().toUpperCase().replace(/\s+/g, '');
    return ({SMALL:'S',MEDIUM:'M',LARGE:'L','2XL':'XXL','XXXL':'3XL','XXXXL':'4XL'})[s] || s;
  }

  function topSizePoints(profile) {
    var pts = {};
    (profile.topSizes || []).forEach(function (size) {
      var i = TOP_SIZES.indexOf(normalizeSize(size));
      if (i < 0) return;
      pts[i] = 50;
      // Only an explicit oversized choice allows one size up.
      if (profile.oversized && i + 1 < TOP_SIZES.length && !pts[i + 1]) pts[i + 1] = 35;
    });
    return pts;
  }

  function waistPoints(profile) {
    var pts = {};
    (profile.waistSizes || []).forEach(function (s) {
      var w = waistOf(s);
      if (w != null) pts[w] = 50;
    });
    return pts;
  }

  function prepare(profile) {
    return {
      p: profile,
      topPts: topSizePoints(profile),
      waistPts: waistPoints(profile),
      now: Math.floor(Date.now() / 1000)
    };
  }

  function score(prod, ctx, relax) {
    relax = relax || {};
    var p = ctx.p;
    var s = 0;
    var fam = familyOf(prod);
    var isBottom = !!BOTTOM_FAMILIES[fam];

    // ---- size
    if (!relax.size) {
      var sizes = sizesOf(prod);
      var best = 0;
      if (isBottom) {
        if ((p.waistSizes || []).length) {
          for (var i = 0; i < sizes.length; i++) {
            var w = waistOf(sizes[i]);
            if (w == null) continue;
            if (ctx.waistPts[w]) best = Math.max(best, ctx.waistPts[w]);
          }
        } else {
          best = 10; // no bottoms size given — do not punish, do not boost
        }
      } else if ((p.topSizes || []).length) {
        for (var j = 0; j < sizes.length; j++) {
          var idx = TOP_SIZES.indexOf(normalizeSize(sizes[j]));
          if (idx >= 0 && ctx.topPts[idx]) best = Math.max(best, ctx.topPts[idx]);
        }
      } else {
        best = 10;
      }
      s += best;
    }

    // ---- style (the strongest signal after size)
    if (!relax.style && (p.styles || []).length) {
      var st = prod.st || [];
      var hits = 0;
      for (var k = 0; k < st.length; k++) {
        if (p.styles.indexOf(st[k]) !== -1) hits++;
      }
      s += Math.min(hits * 30, 60);
    }

    // ---- brand
    if (!relax.brand && (p.brands || []).length && prod.br) {
      if (p.brands.indexOf(prod.br) !== -1) s += 40;
    }

    // ---- family
    if (!relax.family && (p.families || []).length && fam) {
      if (p.families.indexOf(fam) !== -1) s += 20;
      else s -= 10;
    }

    // ---- freshness & condition, small tiebreakers
    if (prod.cd && prod.cd.indexOf('Excellent') === 0) s += 5;
    if (prod.nw && ctx.now - prod.nw < 60 * 60 * 24 * 14) s += 8;
    if (prod.cp && prod.cp > prod.pr) s += 3;

    return s;
  }

  function sizeMatches(size, family, ctx) {
    if (BOTTOM_FAMILIES[family]) {
      return !(ctx.p.waistSizes || []).length || !!ctx.waistPts[waistOf(size)];
    }
    return !(ctx.p.topSizes || []).length || !!ctx.topPts[TOP_SIZES.indexOf(normalizeSize(size))];
  }

  // Category, available size and gender are requirements, never ranking bonuses.
  function allowed(prod, profile, ctx) {
    if (prod.available === false) return false;
    var g = genderOf(prod);
    if (profile.gender === 'men' && (g === 'Women' || g === 'Youth')) return false;
    if (profile.gender === 'women' && g === 'Youth') return false;
    var family = familyOf(prod);
    if ((profile.families || []).length && profile.families.indexOf(family) === -1) return false;
    var variants = prod.av;
    if (Array.isArray(variants)) {
      return variants.some(function(v) { return sizeMatches(v.sz, family, ctx); });
    }
    return sizesOf(prod).some(function(size) { return sizeMatches(size, family, ctx); });
  }

  /* Deals the ranked list out one category at a time, so the grid shows an even
     spread instead of 60 jackets followed by 3 pairs of shorts. Within each
     category the score order is preserved, and a category that runs out simply
     stops contributing. */
  function balance(scored, profile) {
    var keys = (profile.families || []).slice();
    if (keys.length < 2) return scored;

    var buckets = {};
    keys.forEach(function (k) { buckets[k] = []; });
    var rest = [];
    scored.forEach(function (x) {
      var f = familyOf(x.p);
      if (buckets[f]) buckets[f].push(x);
      else rest.push(x);
    });

    // How many each category can contribute before one runs dry — that is the
    // even share. Anything past it is appended in score order.
    var out = [];
    var row = 0;
    var dealing = true;
    while (dealing) {
      dealing = false;
      for (var i = 0; i < keys.length; i++) {
        var b = buckets[keys[i]];
        if (b[row]) { out.push(b[row]); dealing = true; }
      }
      row++;
    }
    return out.concat(rest);
  }

  // Never relax category or size to reach a minimum number of products.
  function rank(products, profile) {
    var ctx = prepare(profile);
    var scored = products.filter(function(prod) { return allowed(prod, profile, ctx); }).map(function(prod) {
      var p = Object.assign({}, prod);
      var family = familyOf(prod);
      if (Array.isArray(prod.av)) {
        var matches = prod.av.filter(function(v) { return sizeMatches(v.sz, family, ctx); });
        var chosen = matches[0];
        p.sz = matches.map(function(v) { return v.sz; }).filter(function(v,i,a) { return a.indexOf(v) === i; }).join('|');
        p.vid = chosen.id; p.pr = chosen.pr; p.cp = chosen.cp;
      }
      return {p:p, s:score(p,ctx)};
    });
    scored.sort(function(a,b) { return b.s-a.s || (b.p.nw || 0)-(a.p.nw || 0); });
    return {items:balance(scored,profile), widened:false, pool:scored.length};
  }

  /* ---------------------------------------------------------------
     Newsletter signup — Shopify customer form (Klaviyo syncs from it).
     Optional direct Klaviyo push when a list id is configured.
     --------------------------------------------------------------- */
  function subscribe(email, phone, profile, klaviyo) {
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', email);
    body.append('contact[tags]', 'newsletter,style-quiz');
    if (phone) body.append('contact[phone]', phone);

    var jobs = [
      fetch(root() + '/contact#contact_form', {
        method: 'POST',
        body: body,
        headers: { 'X-Requested-With': 'fetch' }
      }).catch(function () {})
    ];

    if (klaviyo && klaviyo.company && klaviyo.list) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  phone_number: phone || undefined,
                  properties: {
                    style_gender: profile.gender,
                    style_families: profile.families,
                    style_top_sizes: profile.topSizes,
                    style_oversized: profile.oversized,
                    style_waist: profile.waistSizes,
                    style_styles: profile.styles,
                    style_brands: profile.brands
                  }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: klaviyo.list } } }
        }
      };
      jobs.push(
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyo.company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(payload)
        }).catch(function () {})
      );
    }

    return Promise.all(jobs);
  }

  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }

  function money(cents) {
    var v = (cents || 0) / 100;
    var f = lang() === 'fr'
      ? v.toFixed(2).replace('.', ',') + ' $'
      : '$' + v.toFixed(2);
    return f;
  }

  window.CaroleStyle = {
    KEY: KEY,
    TOP_SIZES: TOP_SIZES,
    WAIST_SIZES: WAIST_SIZES,
    FAMILIES: FAMILIES,
    STYLES: STYLES,
    BRANDS: BRANDS,
    lang: lang,
    t: t,
    label: label,
    blank: blank,
    get: get,
    isComplete: isComplete,
    save: save,
    clear: clear,
    seen: seen,
    markSeen: markSeen,
    loadFeed: loadFeed,
    rank: rank,
    familyOf: familyOf,
    genderOf: genderOf,
    subscribe: subscribe,
    track: track,
    money: money,
    root: root
  };

  document.dispatchEvent(new CustomEvent('carole:style:ready'));
})();

